import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(cents: number, currency = "EUR"): string {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency,
  }).format(cents / 100);
}

export function formatDate(date: Date | string): string {
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "medium",
  }).format(new Date(date));
}

export function formatDateTime(date: Date | string): string {
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(date));
}

/**
 * Show.ticketsSold is the absolute number of tickets sold (not a percentage).
 * Returns the value as-is if present, null otherwise.
 * @deprecated Use show.ticketsSold directly — this wrapper is kept for backward compatibility.
 */
export function soldCountFromOccupancyPercent(
  ticketsSold: number | null | undefined,
  _capacity?: number | null | undefined
): number | null {
  if (ticketsSold == null) return null;
  return ticketsSold;
}
